/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  fieldData: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.GetFieldOverviewAction.REQUEST_FIELD_DATA:
      return {
        ...state
      };
    case actions.GetFieldOverviewAction.FIELD_DATA_RECEIVED:
      return {
        ...state,
        fieldData: action.data?.Response ?? action.data
        // userid: action.payload.user_ID,
        // projectid: action.payload.project_ID,
      };

    default:
      return state;
  }
};

export default reducer;
